module.exports = __webpack_public_path__ + "static/img/icon_gongan.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/icon_gongan.png
// module id = jvJd
// module chunks = 1